import { styled } from "@linaria/react";
import { Tooltip } from "primereact/tooltip";
import { styleTokens } from "@ideally-ltd/design-tokens";

const PTooltip = styled(Tooltip)<{ ref: React.LegacyRef<Tooltip> }>`
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0);
  &.p-tooltip.p-tooltip-right .p-tooltip-arrow {
    border-right-color: black;
  }
  &.p-tooltip.p-tooltip-left .p-tooltip-arrow {
    border-left-color: black;
  }
  &.p-tooltip.p-tooltip-top .p-tooltip-arrow {
    border-top-color: black;
  }
  &.p-tooltip.p-tooltip-bottom .p-tooltip-arrow {
    border-bottom-color: black;
  }
  .p-tooltip-text {
    background-color: ${styleTokens.tooltip.background};
    color: ${styleTokens.tooltip.color};
    border: 1px solid black;
    box-shadow: ${styleTokens.card.shadow};
  }
  &.p-tooltip-small {
    max-width: 180px;
    .p-tooltip-text {
      font-size: 0.875rem;
    }
  }
  &.p-tooltip-normal {
    max-width: 440px;
    .p-tooltip-text {
      font-size: 1rem;
    }
  }
  &.p-tooltip-large {
    max-width: 36rem;
    .p-tooltip-text {
      font-size: 1rem;
    }
  }

  &.p-tooltip-secondary {
    backdrop-filter: none;
    padding: 0;
    margin-top: 0.25em;
    border-radius: 0.5rem;
    & > div.p-tooltip-text {
      border-radius: 0.5rem;

      border: 1px solid ${styleTokens.Surface.Border.main};
      background: rgba(255, 255, 255, 0.88);

      /* overlay/container/shadow */
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
      backdrop-filter: none !important;
    }
    &.p-tooltip-top:not(.p-tooltip-follow-mouse) {
      margin-top: 6px;
    }
  }
`;
const TooltipWrapper = styled.div`
  width: fit-content;
`;
const TooltipWrapperI = styled.i`
  width: fit-content;
  font-size: 19px;
`;

export const PTooltipStyle = {
  PTooltip,
  TooltipWrapper,
  TooltipWrapperI,
};
